
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11196",
                "data-name": "矩形 11196",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(-0.032 0.064)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_237",
        "data-name": "蒙版组 237",
        "class": "cls-2",
        "transform": "translate(0.032 -0.064)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "Smokingarea",
            "class": "cls-3",
            "d": "M64.608,123.685a4.388,4.388,0,0,1,4.275-4.219c.237,0,.356.234.356.469a.507.507,0,0,1-.475.469,3.172,3.172,0,0,0-3.206,3.164,3.376,3.376,0,0,0,3.325,3.281,3.946,3.946,0,0,0,2.256-.7,1.925,1.925,0,0,1,1.544-.7,2.446,2.446,0,0,1,2.375,2.344,2.537,2.537,0,0,1-2.375,2.344c-.237,0-.356-.234-.356-.469s.119-.469.356-.469a1.406,1.406,0,1,0,0-2.812,1.164,1.164,0,0,0-1.069.469l-.119.117a4.449,4.449,0,0,1-2.612.938A4.306,4.306,0,0,1,64.608,123.685ZM75.3,130.951a.557.557,0,0,1,.594.586v2.344a.594.594,0,0,1-1.187,0v-2.344A.557.557,0,0,1,75.3,130.951Zm-2.375,0a.557.557,0,0,1,.594.586v2.344a.594.594,0,0,1-1.187,0v-2.344A.557.557,0,0,1,72.92,130.951Zm-15.438,0h13.3l.356.352v2.578a.557.557,0,0,1-.594.586H57.483a.557.557,0,0,1-.594-.586v-2.344A.557.557,0,0,1,57.483,130.951Zm.594,1.172v1.172H69.951v-1.172Z",
            "transform": "translate(-53.921 -114.402)"
          }
        }
      ]
    }
  ]
})
    }
  